export default __webpack_public_path__ + "static/media/phone-icon.d18cae7b.svg";